import {BdGraphNode, BdGraph} from '../../../lib/graph/graph.model';

// Model for node available in state for user interaction with scene graph
export class ViewTreeNode extends BdGraphNode {
    label: string;
    boolState: {
        pickable: boolean;
        renderable: boolean;
        shown: boolean;
        expanded: boolean;
    };

    constructor(data: any) {
        super(data.id);
        this.label = data.label || '';
        this.boolState.pickable = data.hasOwnProperty('pickable') ? data.pickable : true;
        this.boolState.renderable = data.renderable || false;
        this.boolState.shown = data.shown || false;
        this.boolState.expanded = data.expanded || false;
    }
}
